var _MessageHelper = require("./MessageHelper");

module.exports = {
  buildMatchDateMessage: _MessageHelper.buildMatchDateMessage
};